export default __webpack_public_path__ + "static/media/DSS_HeroBanner_675x300_Tools-Section_Final.54d06117.gif";